import withAvatarTrabajador from "../../hoc/Avatar/withAvatarTrabajador";
import AvatarUsuario from "../../view/components/Avatar/AvatarUsuario";

export default withAvatarTrabajador(AvatarUsuario);